
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ZNsj", function(module, exports) {
/* BannerContainer.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $HJnwX = parcelRequire("HJnwX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jmjWc = parcelRequire("jmjWc");


const $10edbccaeb321332$export$d71d84f1864a608a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4qwYp",
    name: "SuperAdminBanner",
    loader: async ()=>(await (parcelRequire("fNmeA"))).SuperAdminBanner
});


/* PageWasInactiveBanner.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $3PNw6 = parcelRequire("3PNw6");


var $irVI7 = parcelRequire("irVI7");


var $3XjWl = parcelRequire("3XjWl");


var $2KpT3 = parcelRequire("2KpT3");





var $aJv6Q = parcelRequire("aJv6Q");


var $hrAmX = parcelRequire("hrAmX");


var $18HQ4 = parcelRequire("18HQ4");

const $880f9466dc5f2c8e$var$i18n = (0, $kSwu1.defineMessages)({
    pageWasBackgrounded: {
        id: "browser-status-indicator.page.was.backgrounded",
        defaultMessage: "Your content may not have fully loaded. Try to {refreshLink}"
    },
    refreshLink: {
        id: "browser-status-indicator.refresh.the.page",
        defaultMessage: "refresh now"
    }
});
const $880f9466dc5f2c8e$var$BANNER_NAME = 'PageWasInactiveBanner';
const $880f9466dc5f2c8e$var$BANNER_HEIGHT = 32; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $880f9466dc5f2c8e$var$PageWasInactiveBannerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq _4t3izwfg _1e0c1txw _bfhkysee _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $880f9466dc5f2c8e$var$RefreshLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.StyledRefreshLink), {
        target: "_blank",
        onClick: ()=>window.location.reload()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $880f9466dc5f2c8e$var$i18n.refreshLink, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, text)));
// Experiences to track
const $880f9466dc5f2c8e$var$EXPERIENCES = [
    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
]; // Delay before making this banner become visible
// when viewing a tab that was previously hidden.
const $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY = 1000;
const $880f9466dc5f2c8e$export$91f065510e8e6998 = /*#__PURE__*/ (0, $cozmU.memo)(({ bannerState: bannerState })=>{
    const [documentVisible, setDocumentVisible] = (0, $cozmU.useState)(false);
    const experienceStates = $880f9466dc5f2c8e$var$EXPERIENCES.map((0, $3XjWl.useExperienceState));
    (0, $cozmU.useEffect)(()=>{
        const changeVisibility = ()=>{
            // When a tab's visibility changes, wait a small amount before updating documentVisible.
            // This prevents a flicker of this banner that sometimes occurs
            // when a tab that is loading in the background becomes visible.
            setTimeout(()=>{
                setDocumentVisible(!document.hidden);
            }, $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY);
        };
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>document.removeEventListener('visibilitychange', changeVisibility);
    });
    const showBanner = documentVisible && experienceStates.some((experienceState)=>{
        // dont show the banner if:
        // !experienceState - if an experience has not started
        // !experienceState.timeout - if the experience does not rely on timeout
        if (!experienceState || !experienceState.timeout) return false;
        const { startTime: startTime = 0, timeout: timeout, hasStopped: hasStopped } = experienceState;
        const absoluteDuration = Math.round(window.performance.now() - startTime);
        const adjustedTabActiveTime = absoluteDuration - (0, $2KpT3.getTabInactivityTracker)().getInactiveMillisecondsSince(startTime);
        const insufficientActiveTime = adjustedTabActiveTime < timeout;
        return !hasStopped && insufficientActiveTime;
    });
    if (showBanner) {
        bannerState.show($880f9466dc5f2c8e$var$BANNER_NAME, $880f9466dc5f2c8e$var$BANNER_HEIGHT);
        (0, $3PNw6.addUFOCustomData)({
            isPageWasInactiveBannerDisplayed: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($880f9466dc5f2c8e$var$PageWasInactiveBannerContainer, {
            "data-testid": "inactive-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.FadingSpan), {
            show: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$880f9466dc5f2c8e$var$i18n.pageWasBackgrounded,
            values: {
                refreshLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($880f9466dc5f2c8e$var$RefreshLink, null)
            }
        }))));
    } else {
        bannerState.hide($880f9466dc5f2c8e$var$BANNER_NAME);
        return null;
    }
});
const $880f9466dc5f2c8e$export$6d11cadf32c4517a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($880f9466dc5f2c8e$export$91f065510e8e6998, {
            bannerState: bannerState
        });
    });
});















var $lfcs7 = parcelRequire("lfcs7");


const $a01c89834a203359$var$AdminAnnouncementBannerInner = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "T-Qcy",
    name: "AdminAnnouncementBannerInner",
    loader: async ()=>(await (parcelRequire("hshUE"))).AdminAnnouncementBannerInner
});
const $a01c89834a203359$export$f449ad63dc7e8a0f = ()=>{
    const isPageEligibleForAdminAnnouncementBanner = (0, $lfcs7.useIsPageEligibleForAdminAnnouncementBanner)();
    if (!isPageEligibleForAdminAnnouncementBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a01c89834a203359$var$AdminAnnouncementBannerInner, {
            bannerState: bannerState
        });
    });
};









var $alLTz = parcelRequire("alLTz");


const $a393ba0851d433ea$var$StorageEnforcementBannerLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VZcGs",
    name: "StorageEnforcementBannerLoadable",
    loader: async ()=>(await (parcelRequire("964v5"))).StorageEnforcementBanner
});
const $a393ba0851d433ea$export$8140039602269ff0 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a393ba0851d433ea$var$StorageEnforcementBannerLoadable, null) : null;
};



var $bDgLe = parcelRequire("bDgLe");











var $55fM8 = parcelRequire("55fM8");


var $1LXnB = parcelRequire("1LXnB");








var $i3jcY = parcelRequire("i3jcY");








var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");








var $9DHhW = parcelRequire("9DHhW");





var $gYhNH = parcelRequire("gYhNH");





var $a3jGG = parcelRequire("a3jGG");

const $403d7842519953c9$export$afc8b28843b075c1 = 105;
const $403d7842519953c9$export$41956b146268af93 = 'CookiesConsentBanner';


function $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb(bannerState, bannerRef) {
    const $ = (0, $bDgLe.c)(19);
    const isStableUI = (0, $i3jcY.isStableUIEnabledForTests)();
    const cookiesDialogRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [height, setHeight] = (0, $cozmU.useState)((0, $403d7842519953c9$export$afc8b28843b075c1));
    const prefetchedData = Object.keys(window?.__COOKIE_CONSENT_PREFERENCES__ || {}).length ? window.__COOKIE_CONSENT_PREFERENCES__ : undefined;
    const isSSR = Boolean(undefined);
    let t0;
    bb0: {
        if (isStableUI) {
            t0 = false;
            break bb0;
        }
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $gYhNH.shouldRenderBannerPrefetched)(prefetchedData ?? undefined);
            $[0] = t1;
        } else t1 = $[0];
        const initialValue = t1;
        if (isSSR && initialValue) (0, $a3jGG.ssrBannerManager).registerBanner({
            name: (0, $403d7842519953c9$export$41956b146268af93),
            height: (0, $403d7842519953c9$export$afc8b28843b075c1)
        });
        t0 = initialValue;
    }
    const shouldRenderInitial = t0;
    const [shouldRender, setShouldRender] = (0, $cozmU.useState)(isSSR ? shouldRenderInitial : undefined);
    if (shouldRender) bannerState?.show((0, $403d7842519953c9$export$41956b146268af93), height);
    else if (shouldRender === false) bannerState?.hide((0, $403d7842519953c9$export$41956b146268af93));
    let t1;
    if ($[1] !== bannerRef) {
        t1 = ()=>{
            if (cookiesDialogRef?.current) return cookiesDialogRef?.current;
            if (!bannerRef?.current) return null;
            const childDivs = bannerRef?.current.getElementsByTagName("div");
            let cookiesDialog = null;
            for (const element of Object.values(childDivs)){
                if (!element.offsetHeight) continue;
                cookiesDialog = element;
                break;
            }
            cookiesDialogRef.current = cookiesDialog;
            return cookiesDialog;
        };
        $[1] = bannerRef;
        $[2] = t1;
    } else t1 = $[2];
    const findCookiesDialog = t1;
    let t2;
    let t3;
    if ($[3] !== shouldRender) {
        t2 = ()=>{
            if (shouldRender || shouldRenderInitial) (0, $3PNw6.addUFOCustomData)({
                isCookieConsentBannerDisplayed: true,
                ...prefetchedData && {
                    prefetchedConsentPreferences: JSON.stringify(prefetchedData)
                }
            });
        };
        t3 = [
            shouldRender,
            shouldRenderInitial,
            prefetchedData
        ];
        $[3] = shouldRender;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== createAnalyticsEvent || $[7] !== shouldRender) {
        t4 = ()=>{
            if (shouldRender) createAnalyticsEvent({
                type: "sendOperationalEvent",
                action: "rendered",
                actionSubject: "cookiesConsentBanner"
            }).fire();
        };
        t5 = [
            shouldRender,
            createAnalyticsEvent
        ];
        $[6] = createAnalyticsEvent;
        $[7] = shouldRender;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[10] !== findCookiesDialog) {
        t6 = ()=>{
            const cookiesDialog_0 = findCookiesDialog();
            if (!cookiesDialog_0) return;
            (0, $3PNw6.addUFOCustomData)({
                cookieBannerHeight: cookiesDialog_0.offsetHeight
            });
            setHeight(cookiesDialog_0.offsetHeight);
        };
        $[10] = findCookiesDialog;
        $[11] = t6;
    } else t6 = $[11];
    const onWidthChange = t6;
    let t7;
    if ($[12] !== onWidthChange) {
        t7 = ()=>{
            setShouldRender(true);
            onWidthChange();
        };
        $[12] = onWidthChange;
        $[13] = t7;
    } else t7 = $[13];
    const showBanner = t7;
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setShouldRender(false);
        };
        $[14] = t8;
    } else t8 = $[14];
    const hideBanner = t8;
    let t9;
    if ($[15] !== onWidthChange || $[16] !== shouldRender || $[17] !== showBanner) {
        t9 = {
            shouldRender: shouldRender,
            showBanner: showBanner,
            hideBanner: hideBanner,
            onWidthChange: onWidthChange,
            prefetchedData: prefetchedData
        };
        $[15] = onWidthChange;
        $[16] = shouldRender;
        $[17] = showBanner;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
}



// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62400dd446426ff7$var$Banner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62400dd446426ff7$var$BannerContent = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

const $62400dd446426ff7$var$ConsentBannerComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BMpKa",
    name: "ConsentBannerComponent",
    loader: async ()=>(await (parcelRequire("5lvGj"))).ConsentBannerWrapper
});
const $62400dd446426ff7$var$CookieConsentBannerComponentInSuspense = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    if ((0, $6mKj3.expVal)("confluence_cookie_consent_banner_suspense", "isEnabled", false)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return children;
};
const $62400dd446426ff7$var$CookiesConsentBannerComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { bannerState: bannerState } = t0;
    const bannerRef = (0, $cozmU.useRef)(null);
    const { onWidthChange: onWidthChange, showBanner: showBanner, hideBanner: hideBanner, prefetchedData: prefetchedData } = (0, $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb)(bannerState, bannerRef);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== onWidthChange) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onWidthChange, 50);
        $[0] = onWidthChange;
        $[1] = t1;
    } else t1 = $[1];
    const onResize = t1;
    let t2;
    if ($[2] !== onResize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
            setWidth: onResize
        });
        $[2] = onResize;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== renderServerPlaceholder) {
        t3 = {
            isSSR: renderServerPlaceholder
        };
        $[4] = renderServerPlaceholder;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== hideBanner || $[7] !== prefetchedData || $[8] !== showBanner || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62400dd446426ff7$var$ConsentBannerComponent, {
            product: "Confluence",
            onShow: showBanner,
            onHide: hideBanner,
            initialPreferences: prefetchedData,
            newMinHeight: (0, $403d7842519953c9$export$afc8b28843b075c1),
            ssrOptions: t3
        });
        $[6] = hideBanner;
        $[7] = prefetchedData;
        $[8] = showBanner;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t2 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62400dd446426ff7$var$Banner, {
            ref: bannerRef,
            role: "banner",
            "data-testid": "cookie-consent-banner",
            "data-vc": "cookie-consent-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62400dd446426ff7$var$BannerContent, null, t2, t4));
        $[11] = t2;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
const $62400dd446426ff7$export$494acd77efce1d72 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, $62400dd446426ff7$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $62400dd446426ff7$var$_temp(bannerState) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62400dd446426ff7$var$CookieConsentBannerComponentInSuspense, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62400dd446426ff7$var$CookiesConsentBannerComponent, {
        bannerState: bannerState
    }));
}












var $gJN0g = parcelRequire("gJN0g");


var $i1t43 = parcelRequire("i1t43");











var $eSDUO = parcelRequire("eSDUO");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $04e9M = parcelRequire("04e9M");


var $cMvQV = parcelRequire("cMvQV");

// This file was automatically generated and should not be edited.
const $09adc8c702586d16$export$88284c4a582e5a0c = /Edge?\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/(7[89]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(16\.([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(8[5-9]|9\d|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(16[._]([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android:?[ /-](129|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Mobile Safari.+OPR\/([89]\d|\d{3,})\.\d+\.\d+|Android.+Firefox\/(13\d|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(129|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+(UC? ?Browser|UCWEB|U3)[ /]?(15\.([5-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)\.\d+|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+|Android.+MQ{2}Browser\/(14(\.(9|\d{2,})|)|(1[5-9]|[2-9]\d|\d{3,})(\.\d+|))(\.\d+|)|K[Aa][Ii]OS\/(3\.\d+|([4-9]|\d{2,})\.\d+)(\.\d+|)/;


const $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c = ()=>!(0, $09adc8c702586d16$export$88284c4a582e5a0c).test(navigator.userAgent);





const $a0d38a398101db6d$var$BANNER_HEIGHT = 72; // 72px when gridSize = 8px
const $a0d38a398101db6d$var$BANNER_NAME = 'UnsupportedBrowserBanner';
const $a0d38a398101db6d$var$messages = (0, $kSwu1.defineMessages)({
    bannerMessage: {
        id: "unsupported-browser-banner.banner-message",
        defaultMessage: "Your browser is <link>unsupported</link>. Switch or upgrade to maintain optimal performance."
    },
    bannerLink: {
        id: "unsupported-browser-banner.banner-link",
        defaultMessage: "unsupported"
    }
});
const $a0d38a398101db6d$var$BannerLink = (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://support.atlassian.com/atlassian-account/docs/supported-browsers-for-atlassian-cloud-products/",
        target: "_blank",
        rel: "noreferrer noopener"
    }, str);
const $a0d38a398101db6d$var$UnsupportedBrowserBannerComponent = ({ bannerState: bannerState, setIsBannerClosed: setIsBannerClosed, isBannerClosed: isBannerClosed })=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const bannerClosedByUser = (0, $17wUi.confluenceSessionStorageInstance).getItemAsBoolean((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER);
        if (bannerClosedByUser) {
            setIsBannerClosed(true);
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
        }
    }, [
        setIsBannerClosed,
        isBannerClosed,
        bannerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSDUO.DismissibleBanner), {
        height: $a0d38a398101db6d$var$BANNER_HEIGHT,
        isWarning: true,
        onDismiss: ()=>{
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
            setIsBannerClosed(true);
            (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER, true);
        }
    }, intl.formatMessage($a0d38a398101db6d$var$messages.bannerMessage, {
        link: $a0d38a398101db6d$var$BannerLink
    }));
};
const $a0d38a398101db6d$export$77b99dfa740609c2 = ()=>{
    const [isBannerClosed, setIsBannerClosed] = (0, $cozmU.useState)(true);
    const failedFullCapabilitiesBrowserCheck = (0, $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c)();
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cozmU.useEffect)((0, $cMvQV.setUserAgent), []);
    // Display banner if full browser capabilities check failed
    (0, $cozmU.useEffect)(()=>{
        if (failedFullCapabilitiesBrowserCheck) setIsBannerClosed(false);
    }, [
        failedFullCapabilitiesBrowserCheck,
        setIsBannerClosed
    ]);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($gJN0g)))(navigator.userAgent);
    const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
    // collect analytics
    (0, $cozmU.useEffect)(()=>{
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent({
                source: 'unsupportedBrowserBanner',
                action: 'executed',
                actionSubject: 'browserRuntimeCheck',
                attributes: {
                    failedFullBrowserCheck: failedFullCapabilitiesBrowserCheck,
                    browserName: browserName,
                    browserVersion: browserVersion
                }
            });
        });
    }, [
        failedFullCapabilitiesBrowserCheck,
        browserName,
        browserVersion
    ]);
    if (isBannerClosed || !failedFullCapabilitiesBrowserCheck || (0, $cMvQV.isNativeMobile)() // Do not render the banner in the Confluence native mobile app
    ) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        bannerState.show($a0d38a398101db6d$var$BANNER_NAME, $a0d38a398101db6d$var$BANNER_HEIGHT);
        (0, $3PNw6.addUFOCustomData)({
            isUnsupportedBrowserBannerDisplayed: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a0d38a398101db6d$var$UnsupportedBrowserBannerComponent, {
            bannerState: bannerState,
            setIsBannerClosed: setIsBannerClosed,
            isBannerClosed: isBannerClosed
        });
    }));
};



var $6wrL8 = parcelRequire("6wrL8");


var $luv00 = parcelRequire("luv00");

const $6d2b0b868a2f629c$export$75cf49eb39e36c7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqsw1n9t _1bsb1osq _154iidpf _1ltvidpf _1pby1fss",
            __cmplp.className
        ])
    });
});
const $6d2b0b868a2f629c$var$BannerContainerComponent = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d2b0b868a2f629c$export$75cf49eb39e36c7, {
        "data-vc": "banner-container-component",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10edbccaeb321332$export$d71d84f1864a608a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $880f9466dc5f2c8e$export$6d11cadf32c4517a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a393ba0851d433ea$export$8140039602269ff0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a01c89834a203359$export$f449ad63dc7e8a0f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62400dd446426ff7$export$494acd77efce1d72), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a0d38a398101db6d$export$77b99dfa740609c2), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wrL8.DevToolsBanner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $HJnwX.BannerSpacer), props));
};
const $6d2b0b868a2f629c$export$f316edcbf748c37b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($6d2b0b868a2f629c$var$BannerContainerComponent);
module.exports["BannerPositioner"] = $6d2b0b868a2f629c$export$75cf49eb39e36c7;
module.exports["BannerContainer"] = $6d2b0b868a2f629c$export$f316edcbf748c37b;

});

parcelRegister("HJnwX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kNIYN = parcelRequire("kNIYN");


var $jzEl8 = parcelRequire("jzEl8");


var $hrAmX = parcelRequire("hrAmX");

const $5bf79a09d86231d0$export$5c256b7d48e4b02a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1neqek2": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4t3i2nrh",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $5bf79a09d86231d0$var$BANNER_SPACER_CONTAINER_SELECTORS = [
    `.banner-spacer-container`
];
const $5bf79a09d86231d0$var$renderSpacer = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight(false);
        const bannerList = bannerState.getBannerList();
        return bannerHeight > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5bf79a09d86231d0$export$5c256b7d48e4b02a, {
            height: bannerHeight,
            "data-testid": "banner-spacer",
            "data-vc": `banner-spacer-${bannerList}`
        }) : null;
    });
};
const $5bf79a09d86231d0$var$renderPortalSpacer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $5bf79a09d86231d0$var$BANNER_SPACER_CONTAINER_SELECTORS,
        attempts: 1,
        retryDelay: 500,
        portalNode: $5bf79a09d86231d0$var$renderSpacer()
    });
const $5bf79a09d86231d0$export$6801ec5f8af8462d = /*#__PURE__*/ (0, $cozmU.memo)(({ usePortalSpacer: usePortalSpacer = false })=>usePortalSpacer ? $5bf79a09d86231d0$var$renderPortalSpacer() : $5bf79a09d86231d0$var$renderSpacer());
module.exports["BannerSpacer"] = $5bf79a09d86231d0$export$6801ec5f8af8462d;

});

parcelRegister("jzEl8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
function $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode = window.document) {
    if (!rootNode) return [];
    return Array.from(rootNode.querySelectorAll(selectors.join(',')));
}
function $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(domElement) {
    if (!domElement.hasAttributes()) return {};
    return Object.values(domElement.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
}
const $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 = /*#__PURE__*/ (0, $cozmU.memo)(function LegacyDOMBridge({ selectors: selectors, attempts: attempts = 1, retryDelay: retryDelay = 50, rootNode: rootNode, portalNode: portalNode, replacePlaceholderWith: replacePlaceholderWith, deleteExistingContent: deleteExistingContent = true }) {
    const [portals, setPortals] = (0, $cozmU.useState)([]);
    const workerInProgressRef = (0, $cozmU.useRef)(false);
    const portalsRef = (0, $cozmU.useRef)([]);
    const replaceDOMElementsWithPortal = (0, $cozmU.useCallback)((attemptsLeft)=>{
        workerInProgressRef.current = true;
        $6cbcb1ce2cb81a03$var$getLegacyElements(selectors, rootNode).forEach((node)=>{
            const currentNodeAttrs = $6cbcb1ce2cb81a03$var$getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(portalNode, currentNodeAttrs);
                portalsRef.current.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(reactEl, targetNode));
            }
        });
        const remaining = attemptsLeft - 1;
        setPortals([
            ...portalsRef.current
        ]);
        if (remaining > 0) window.setTimeout(()=>{
            replaceDOMElementsWithPortal(remaining);
        }, retryDelay);
        else workerInProgressRef.current = false;
    }, [
        selectors,
        rootNode,
        portalNode,
        replacePlaceholderWith,
        deleteExistingContent,
        retryDelay
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (attempts > 0 && !workerInProgressRef.current) {
            const timerId = setTimeout(()=>{
                replaceDOMElementsWithPortal(attempts);
            }, 0);
            return ()=>clearTimeout(timerId);
        }
    }, [
        attempts,
        replaceDOMElementsWithPortal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, portals);
});
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("fNmeA", function(module, exports) {

let $b7fcade449bab862$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7fcade449bab862$var$load("kiqoj").then(()=>parcelRequire('hnH0O'));

});

parcelRegister("3XjWl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const $ = (0, $bDgLe.c)(7);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== experienceName || $[1] !== experienceTracker) {
        t0 = experienceTracker.getExperienceState(experienceName);
        $[0] = experienceName;
        $[1] = experienceTracker;
        $[2] = t0;
    } else t0 = $[2];
    const [experienceState, setExperienceState] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[3] !== experienceName || $[4] !== experienceTracker) {
        t1 = ()=>experienceTracker.subscribe((e)=>{
                if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
            });
        t2 = [
            experienceName,
            experienceTracker
        ];
        $[3] = experienceName;
        $[4] = experienceTracker;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return experienceState;
};
module.exports["useExperienceState"] = $a5d6810b007644fc$export$4a4fb33de7d01f75;

});

parcelRegister("18HQ4", function(module, exports) {
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhkysee _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhk1y9u" : "_bfhkysee",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $9aYkv.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pwu06 _1wyb1crf _syaz1rpy _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1rr0 _11q71rpy _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _k48pwu06 _syaz1oa5",
            __cmplp.className
        ])
    });
});
module.exports["StatusIndicator"] = $4dfb2d8a6603cd21$export$b4f88f0ca5784eef;
module.exports["StyledText"] = $4dfb2d8a6603cd21$export$31ea92f3997410dd;
module.exports["FadingSpan"] = $4dfb2d8a6603cd21$export$bb5d4b172e6970cd;
module.exports["EllipsisContainer"] = $4dfb2d8a6603cd21$export$91672a4b819b5126;
module.exports["AnimatedDot"] = $4dfb2d8a6603cd21$export$c30cc6d619162254;
module.exports["StyledRefreshLink"] = $4dfb2d8a6603cd21$export$b9ead157d7292e86;

});

parcelRegister("lfcs7", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

const $d5dcaba09c1feb05$export$8254d0a1f47e67b2 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return edition === 'PREMIUM' || edition === 'STANDARD';
};
module.exports["useIsPageEligibleForAdminAnnouncementBanner"] = $d5dcaba09c1feb05$export$8254d0a1f47e67b2;

});

parcelRegister("hshUE", function(module, exports) {

let $cb52f243d1b2305f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb52f243d1b2305f$var$load("3mbqY"),
    $cb52f243d1b2305f$var$load("hJj0Z"),
    $cb52f243d1b2305f$var$load("cuWsK"),
    $cb52f243d1b2305f$var$load("35yiN"),
    $cb52f243d1b2305f$var$load("79Tk4"),
    $cb52f243d1b2305f$var$load("daX4F"),
    $cb52f243d1b2305f$var$load("6wr18"),
    $cb52f243d1b2305f$var$load("9cgaG"),
    $cb52f243d1b2305f$var$load("ffEVr"),
    $cb52f243d1b2305f$var$load("hhss7"),
    $cb52f243d1b2305f$var$load("jXx9i"),
    $cb52f243d1b2305f$var$load("jUHie"),
    $cb52f243d1b2305f$var$load("hLmw0"),
    $cb52f243d1b2305f$var$load("2EIkU"),
    $cb52f243d1b2305f$var$load("eRhBr"),
    $cb52f243d1b2305f$var$load("fGW6H"),
    $cb52f243d1b2305f$var$load("kT6dz"),
    $cb52f243d1b2305f$var$load("aAWLw"),
    $cb52f243d1b2305f$var$load("hUS1e")
]).then(()=>parcelRequire('942cv'));

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("964v5", function(module, exports) {

let $69f82a4a862dd545$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69f82a4a862dd545$var$load("6wr18"),
    $69f82a4a862dd545$var$load("ffEVr"),
    $69f82a4a862dd545$var$load("7EorR"),
    $69f82a4a862dd545$var$load("96waY"),
    $69f82a4a862dd545$var$load("4uVag")
]).then(()=>parcelRequire('3Atou'));

});

parcelRegister("1LXnB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $12a75cc47e499450$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $12a75cc47e499450$export$2e2bcd8739ae039 = $12a75cc47e499450$var$WidthObserver;
module.exports["default"] = $12a75cc47e499450$export$2e2bcd8739ae039;

});

parcelRegister("69NJe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("gYhNH", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $jeWt2 = parcelRequire("jeWt2");


var $8SjBl = parcelRequire("8SjBl");


var $fkeeB = parcelRequire("fkeeB");


var $98PmH = parcelRequire("98PmH");

const $7142efb36f0573f7$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $iDrrr.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $fkeeB.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $98PmH.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $8SjBl.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $jeWt2.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $98PmH.getBannerVisibility)(consentPrefsData, ssrOptions);
};
module.exports["shouldRenderBannerPrefetched"] = $7142efb36f0573f7$export$6406464aa126433e;

});

parcelRegister("a3jGG", function(module, exports) {
class $6069cdb664c4b392$export$c5377c2d90c2873e {
    registerBanner({ name: name, height: height }) {
        const bannerIndex = this.banners.findIndex((_banner)=>name === _banner.name);
        if (bannerIndex < 0) this.banners.push({
            name: name,
            height: height
        });
    }
    hasOtherBanners(bannerName) {
        return this.banners.some((banner)=>banner.name !== bannerName);
    }
    getBanners() {
        return this.banners;
    }
    clearBanners() {
        this.banners.length = 0;
    }
    constructor(){
        this.banners = [];
    }
}


const $dadf684901449c5e$export$6f28ab7c6647e579 = new (0, $6069cdb664c4b392$export$c5377c2d90c2873e)();
module.exports["ssrBannerManager"] = $dadf684901449c5e$export$6f28ab7c6647e579;

});

parcelRegister("5lvGj", function(module, exports) {

let $3e477d304d100dfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3e477d304d100dfd$var$load("cuWsK"),
    $3e477d304d100dfd$var$load("35yiN"),
    $3e477d304d100dfd$var$load("kHXvF"),
    $3e477d304d100dfd$var$load("5Mm1x"),
    $3e477d304d100dfd$var$load("hhss7"),
    $3e477d304d100dfd$var$load("hmjlF")
]).then(()=>parcelRequire('hs7Sl'));

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $iDrrr.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("eSDUO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $jEK83 = parcelRequire("jEK83");


var $lMGh1 = parcelRequire("lMGh1");


var $l3wuH = parcelRequire("l3wuH");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1neqek2": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1yt4ze3t _1bsb1osq _vchhusvi _4t3i2nrh _y3gn1h6o _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT = 28; // 28px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_FONT_SIZE = $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT / 2; // 14px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$Banner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _c71l1f4h _1wybdlk8 _k48p1wq8",
            __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
            __cmplp.isWarning ? "_syaz1yd3" : "_syaz15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerContent = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18s81s16 _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_SIZE = 24;
// 24px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_RIGHT_OFFSET = 10;
// 10px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerDismissButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isWarning: isWarning, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4t3i1tcg _1bsb1tcg _80omtlke _kqswstnw _1xi219bv",
            __cmplp.isWarning ? "_bfhk1kmu" : "_bfhk1i45",
            __cmplp.isWarning ? "_syaz1yd3" : "_syaz15cr",
            __cmplp.isWarning ? "_30l31yd3" : "_30l315cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $77f2946a7e231fe8$var$BannerMessages = (0, $kSwu1.defineMessages)({
    closeLabel: {
        id: "banners.dismissible-banner.close-label",
        defaultMessage: "Close"
    }
});
const $77f2946a7e231fe8$export$f43e5701f59b92d6 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { height: height, children: children, onView: t1, onDismiss: t2, isWarning: t3 } = t0;
    const onView = t1 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jEK83))) : t1;
    const onDismiss = t2 === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($jEK83))) : t2;
    const isWarning = t3 === undefined ? false : t3;
    const intl = (0, $kSwu1.useIntl)();
    let t4;
    let t5;
    if ($[0] !== onView) {
        t4 = ()=>{
            onView();
        };
        t5 = [
            onView
        ];
        $[0] = onView;
        $[1] = t4;
        $[2] = t5;
    } else {
        t4 = $[1];
        t5 = $[2];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    bb0: {
        let t7;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                role: "alert"
            };
            $[3] = t7;
        } else t7 = $[3];
        const baseProps = t7;
        if (!isWarning) {
            let t8;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t8 = {
                    ...baseProps,
                    "aria-label": "announcement",
                    tabIndex: 0,
                    role: "region"
                };
                $[4] = t8;
            } else t8 = $[4];
            t6 = t8;
            break bb0;
        }
        t6 = baseProps;
    }
    const accessibilityProps = t6;
    let t7;
    if ($[5] !== isWarning) {
        t7 = isWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            spacing: "spacious",
            label: "Warning icon"
        });
        $[5] = isWarning;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77f2946a7e231fe8$var$BannerText, null, children);
        $[7] = children;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== accessibilityProps || $[10] !== isWarning || $[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77f2946a7e231fe8$var$BannerContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77f2946a7e231fe8$var$Banner, {
            isWarning: isWarning,
            ...accessibilityProps
        }, t7, t8));
        $[9] = accessibilityProps;
        $[10] = isWarning;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== intl) {
        t10 = intl.formatMessage($77f2946a7e231fe8$var$BannerMessages.closeLabel);
        $[14] = intl;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            spacing: "spacious",
            label: t10
        });
        $[16] = t10;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== isWarning || $[19] !== onDismiss || $[20] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77f2946a7e231fe8$var$BannerDismissButton, {
            "data-testid": "banner-dismiss-button",
            onClick: onDismiss,
            isWarning: isWarning,
            role: "button",
            tabIndex: 0
        }, t11);
        $[18] = isWarning;
        $[19] = onDismiss;
        $[20] = t11;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== height || $[23] !== isWarning || $[24] !== t12 || $[25] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($77f2946a7e231fe8$var$BannerContainer, {
            "data-testid": "banner-container",
            height: height,
            isWarning: isWarning
        }, t9, t12);
        $[22] = height;
        $[23] = isWarning;
        $[24] = t12;
        $[25] = t9;
        $[26] = t13;
    } else t13 = $[26];
    return t13;
};
module.exports["DismissibleBanner"] = $77f2946a7e231fe8$export$f43e5701f59b92d6;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("8oSf9"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("8oSf9"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("gsBOn"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("8oSf9", function(module, exports) {

let $61daa43df0c19fd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $61daa43df0c19fd3$var$load("7k0CW"),
    $61daa43df0c19fd3$var$load("96waY"),
    $61daa43df0c19fd3$var$load("6wr18"),
    $61daa43df0c19fd3$var$load("ilUG7"),
    $61daa43df0c19fd3$var$load("efUj2"),
    $61daa43df0c19fd3$var$load("ffEVr"),
    $61daa43df0c19fd3$var$load("5Mm1x"),
    $61daa43df0c19fd3$var$load("hhss7"),
    $61daa43df0c19fd3$var$load("Wowvf"),
    $61daa43df0c19fd3$var$load("eRhBr"),
    $61daa43df0c19fd3$var$load("7EorR"),
    $61daa43df0c19fd3$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("gsBOn", function(module, exports) {

let $bfbc976fa724bf2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfbc976fa724bf2c$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});


//# sourceMappingURL=BannerContainer.cf749f12.js.map
